define('lib/Podio.UI.LeftNavigation',['require','translate','underscore','jquery','jquery.cookie','jquery.scrollTo','lib/Podio.Organizations.Setup','lib/Podio.Transport','lib/Podio.Routes','lib/Podio.UI.Space.ShareSpaceModal','lib/Podio.UI.Modal','lib/Podio.UI.ActionDropdown','lib/Podio.UI.FlashMessage','lib/Podio.Event.UI','lib/Podio.Config','controllers/conversations/Podio.Controllers.Conversations.New'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  require('jquery.cookie');
  require('jquery.scrollTo');

  var organizationsSetup = require('lib/Podio.Organizations.Setup');
  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');
  var shareSpaceModal = require('lib/Podio.UI.Space.ShareSpaceModal');
  var modal = require('lib/Podio.UI.Modal');
  var actionDropdown = require('lib/Podio.UI.ActionDropdown');
  var flashMessage = require('lib/Podio.UI.FlashMessage');
  var eventUI = require('lib/Podio.Event.UI');
  var podioConfig = require('lib/Podio.Config');

  function onToggleSubOrgExpansion(elmTarget, e) {
    var elmSubOrgs = elmTarget.closest('.sub-orgs');
    $('.left-nav .org-navigation .sub-orgs').removeClass('all-spaces').not(elmSubOrgs).removeClass('expanded');
    elmSubOrgs.toggleClass('expanded');
  }

  function onToggleShowAllSpaces(elmTarget, e) {
    var elmParent = elmTarget.closest('.sub-orgs, .org-spaces');
    elmParent.toggleClass('all-spaces');

    if(!elmParent.hasClass('all-spaces')) {
      var elmOrg = elmParent.parents('li.expanded:first');
      $.scrollTo(elmOrg);
    }
  }

  function onToggleOrgExpansion(elmTarget, e) {
    if (!$(e.target).hasClass('org-spanner') && $(e.target).parents('.action-dropdown-wrapper').length === 0) {
      var elmLi = elmTarget.parents('li:first');
      elmLi.find('.body').slideToggle(150, function(){
        elmLi.toggleClass('expanded');
        // Update collapsed org cookie.
        var list = [];
        $('.left-nav .org-navigation li:not(.expanded)').each(function(){
          var currentId = $(this).find('div.header').data('id');
          if (currentId) {
            list.push(currentId);
          }
        });

        $.cookie('collapsed-orgs', list.join(','), {path: '/', domain: podioConfig.base_domain, expires: 365});
      });
    }
  }

  function onActionDropdownOpened(elmTarget) {
    if($(document).height() - elmTarget.offset().top + elmTarget.height() < 400) {
      elmTarget.addClass('bottom-fix');
    }
  }

  function onActionDropdownClosed(elmTarget) {
    elmTarget.removeClass('bottom-fix');
  }

  function onEditOrg(elmTarget, e) {
    var org_id = elmTarget.parents('.header:first').data('id');
    organizationsSetup.showSetupModal(org_id);
  }

  function onDeleteInactiveOrgClicked(elmTarget, e) {
    var boldDomain = '<b>' + elmTarget.data('domain') + '</b>';
    var html = '<p>' + t("We automatically created a new organisation for you because you're the first person using a {0} email address on Podio. #delete-inactive-org").format(boldDomain) + '</p>';
    html += '<p>' + t("If you don't want this to happen, you have two choices: #delete-inactive-org") + '</p>';
    html += '<ol>';
    html += '<li>' + t('{0} and we can move {1} to an organisation of your choice. #delete-inactive-org').format('<a href="https://support.sharefile.com" target="_blank" class="global-support-link">' + t('https://support.sharefile.com #delete-inactive-org') + '</a>', boldDomain) + '</li>';
    html += '<li>' + t('Simply remove the new organisation by clicking the green button below.') + '</li>';
    html += '</ol>';

    modal.showConfirm(t('Remove organization #delete-inactive-org'), html, null, {yes: t('Okay, remove it #delete-inactive-org'), no: t('Cancel'), className: 'confirm-delete-inactive-org-modal' }, function(){
      transport.requestFromElement(elmTarget);
    });
  }

  function onRequestAdminAccessClick(elmTarget, e) {
    var elmHeader = elmTarget.parents('.header:first');
    var orgId = elmHeader.data('id');

    actionDropdown.hideAll();

    transport.getJSON(routes.request_admin_access_organization_path(orgId), {}, function(responseData) {
      var ControllerConversationNew = require('controllers/conversations/Podio.Controllers.Conversations.New');

      ControllerConversationNew.showWithPrePopulate({
        userIds: responseData.data.org_admin_user_ids,
        subject: responseData.data.org_admin_request_subject,
        text: responseData.data.org_admin_request_text
      });
    });
  }

  function onLeaveOrgClicked(elmTarget, e) {
    var elmContent = elmTarget.parents('.org-content');
    var orgId = elmContent.data('org-id');
    var orgName = $('#organization_name').val();

    transport.getJSON(routes.contract_exists_for_org_path({org_id: orgId}), {}, function(responseData) {
      var body;

      if(responseData.data.has_contract) {
        var modalTitle = t('Leave organization #leave_org_modal');
        var modalHeader = t('You cannot leave this organization yet. #leave_org_modal');
        var conversationButton = '';
        body = '<p>' + t('You own a contract on this organization and therefore cannot leave without downgrading or transferring the contract to someone else. #leave_org_modal') + '<p>';
        body += '<p>' + t('Please get in touch with you Podio Support to get help transferring your contract. #leave_org_modal') + '</p>';
        body = "<div class='image-block'><div class='img'><div class='pads-logo'></div></div><div class='bd'><h4 class='modal-delete-confirm-title'>" + modalHeader + "</h4><div class='modal-delete-confirm-body'>"+body+"</div><div class='modal-delete-confirm-buttons buttons'>"+conversationButton+"<a href='' class='button-new secondary close-button'>"+t('Cancel #leave_org_modal')+"</a></div></div></div>";

        modal.show(body, {'title' : modalTitle, height: 140, width: 560});
      }
      else {
        body = '<p>' + t('You will <b>only</b> be able to join this organization again if you are invited back in. If you are the <b>last</b> person in this organization <b>all</b> the spaces, apps and items in this organization will be deleted <b>permanently</b>. #org_page') + '</p>';
        modal.showDeleteConfirm(t('Leave Organization #org_page'), t('Are you sure you want to leave the organization: "{0}"? #org_page').format(_.escape(orgName)), { variant: 'leave', body: body }, function() {
          transport.requestFromElement(elmTarget);
        });
      }

    });
  }

  function onDeleteSpaceClicked(elmTarget, e) {
    var title = t('You are about to delete the space: #spacesettings') + ' ' + elmTarget.data('name');
    var body = t('<b>All</b> users will lose <b>all</b> apps, <b>all</b> contacts and <b>all</b> items in this workspace <b>permanently</b>. <br>This is <b>not recoverable</b>.#spacesettings');
    modal.showDeleteConfirm(t('Delete Space #spacesettings'), title, {body: body}, function() {
      transport.requestFromElement(elmTarget);
    });
  }

  function onCancelTrialOrgClicked(elmTarget, e) {
    var orgName = $('#organization_name').val();
    body = '<p>' + t('You are canceling your <b>trial membership</b>. The organization will be deleted <b>permanently</b>. #org_page') + '</p>';
    modal.showDeleteConfirm(t('Cancel trial Organization #org_page'), t('Are you sure you want to cancel the trial organization: "{0}"? #org_page').format(orgName), { variant: 'cancelTrialOrg', body: body }, function() {
      transport.requestFromElement(elmTarget);
    });
  }


  return {
    leaveOrg: onLeaveOrgClicked,
    deleteSpace: onDeleteSpaceClicked,
    cancelTrialOrg: onCancelTrialOrgClicked,
  };

});

